
        import { createElement as _createElement } from 'react';
import { Fragment as _Fragment } from 'react';
import _map from 'lodash-es/map';
export default function relatedItemsRT () {
    function repeatItems1(items, itemsIndex) {
        return [items(function () {
                function repeatBadge1(badge, badgeIndex) {
                    return _createElement('span', {
                        'className': 'productitem--badge badge--soldout cm_badge cm_badge__' + this.toKebabCase(badge),
                        'key': badge
                    }, '\n          ', badge, '\n        ');
                }
                function repeatI2(i, iIndex) {
                    return _createElement('span', {
                        'key': i,
                        'className': 'cm_star cm_star__' + (!(this.review_average - i) || this.review_average - i < 0.25 ? 'empty' : this.review_average - i < 0.75 ? 'half' : 'full')
                    });
                }
                return _createElement('li', {
                    'className': 'imagestyle--medium productgrid--item productitem--emphasis show-actions--mobile' + (this.on_sale ? ' productitem--sale' : ''),
                    'data-product-item': true,
                    'data-product-quickshop-url': this.url
                }, _createElement('div', {
                    'className': 'productitem',
                    'data-product-item-content': true
                }, _createElement('a', {
                    'className': 'productitem--image-link',
                    'href': this.url,
                    'data-product-page-link': true
                }, _createElement.apply(this, [
                    'figure',
                    {
                        'className': 'productitem--image',
                        'data-product-item-image': true
                    },
                    this.image2 ? _createElement('img', {
                        'className': 'productitem--image-alternate',
                        'src': this.resizeImage(this.image2),
                        'alt': this.removeHTML(this.title),
                        'onError': e => this.onImageError(e, 'image2'),
                        'key': '434'
                    }) : null,
                    _createElement('img', {
                        'className': 'productitem--image-primary',
                        'alt': this.removeHTML(this.title),
                        'src': this.imageOrDefault(this.resizeImage(this.image)),
                        'onError': this.onImageError
                    }),
                    this.out_of_stock ? _createElement('span', {
                        'className': 'productitem--badge badge--soldout',
                        'key': '815'
                    }, ' Sold out ') : null,
                    !this.out_of_stock && this.on_sale ? _createElement('span', {
                        'className': 'productitem--badge badge--sale',
                        'key': '915'
                    }, ' Sale ') : null,
                    this._badges ? _map(this._badges, repeatBadge1.bind(this)) : null
                ])), _createElement('div', { 'className': 'productitem--info' }, _createElement('div', { 'className': 'productitem--price' }, _createElement('div', { 'className': 'price--compare-at visible' }, _createElement('span', { 'className': 'money' }, this.formatPrice(this.compare_at_price))), _createElement('div', { 'className': 'price--main' }, this.price_varies ? _createElement('span', { 'key': '1516' }, 'From: ') : null, _createElement('span', { 'className': 'money' }, this.formatPrice(this.price))), this.set_qty && !this.price_varies ? _createElement('div', {
                    'className': 'price__current--set',
                    'key': '1653'
                }, '\n          Set of ', this.set_qty, ': ', this.formatPrice(this.price * this.set_qty), '\n        ') : null), _createElement('h2', { 'className': 'productitem--title' }, _createElement('a', Object.assign({}, {
                    'href': this.url,
                    'data-product-page-link': true
                }, { dangerouslySetInnerHTML: { __html: this.title } }))), _createElement('span', { 'className': 'productitem--vendor' }, this.vendor && this.vendor_url ? _createElement('a', Object.assign({}, {
                    'href': this.vendor_url,
                    'key': '2062'
                }, { dangerouslySetInnerHTML: { __html: this.vendor } })) : null), [this.review_count ? _createElement.apply(this, [
                        'div',
                        {
                            'className': 'cm_review-stars',
                            'key': '22200'
                        },
                        _map([
                            0,
                            1,
                            2,
                            3,
                            4
                        ], repeatI2.bind(this)),
                        _createElement('span', { 'className': 'cm_review-count' }, '(', this.review_count, ')')
                    ]) : null]), _createElement('div', {
                    'className': 'productitem--actions',
                    'data-product-actions': true
                }, _createElement('div', { 'className': 'productitem--action quickshop-button' }, _createElement('button', {
                    'onClick': window.Convermax.quickView(this),
                    'className': 'productitem--action-trigger button-secondary mdc-ripple-surface mdc-ripple-upgraded',
                    'data-quickshop-full': true,
                    'type': 'button'
                }, '\n          Quick shop\n        ')), _createElement('div', { 'className': 'productitem--action atc--button' }, this.variant_ids.length === 1 && !this.out_of_stock ? _createElement('form', {
                    'method': 'post',
                    'action': '/cart/add',
                    'encType': 'multipart/form-data',
                    'key': '3051'
                }, _createElement('input', {
                    'type': 'hidden',
                    'name': 'id',
                    'value': this.variant_ids
                }), _createElement('input', {
                    'type': 'hidden',
                    'name': 'quantity',
                    'value': this.set_qty || 1
                }), _createElement('button', {
                    'className': 'productitem--action-trigger productitem--action-atc button-primary mdc-ripple-surface mdc-ripple-upgraded',
                    'type': 'submit',
                    'aria-label': 'Add to cart'
                }, _createElement('span', { 'className': 'atc-button--text' }, 'Add to cart', this.set_qty ? ` Set of ${ this.set_qty }` : ''))) : null, this.variant_ids.length > 1 && !this.out_of_stock ? _createElement('a', {
                    'href': this.url,
                    'className': 'productitem--action-trigger productitem--action-atc button-primary mdc-ripple-surface mdc-ripple-upgraded',
                    'key': '3676'
                }, _createElement('span', { 'className': 'atc-button--text' }, 'Choose Options')) : null, this.out_of_stock ? _createElement('button', {
                    'className': 'productitem--action-trigger productitem--action-atc button-primary disabled',
                    'aria-label': 'Out of stock',
                    'disabled': true,
                    'key': '3965'
                }, _createElement('span', { 'className': 'atc-button--text' }, 'Out of stock')) : null)), this.price ? _createElement('p', {
                    'className': 'affirm-as-low-as',
                    'data-amount': this.price * 100,
                    'data-affirm-type': 'logo',
                    'data-affirm-color': 'blue',
                    'key': '4229'
                }) : null));
            }, { count: undefined })];
    }
    return _createElement('div', { 'className': 'cm_related-products' }, _createElement('div', { 'className': 'cm_related-products-title-container' }, _createElement('h2', { 'className': 'product-section--title product-recommendations--title cm_related-products-title' }, 'You may also like')), _createElement.apply(this, [
        'div',
        { 'className': 'product-section--content product-row cm_related-products-list cmRepeater_items' },
        _map(this.items, repeatItems1.bind(this))
    ]));
}
        export const componentNames = []